var map = {
	"./classic/de.html": [
		2552,
		27
	],
	"./classic/en.html": [
		2553,
		28
	],
	"./classic/es.html": [
		2554,
		29
	],
	"./classic/fr.html": [
		2555,
		30
	],
	"./classic/it.html": [
		2556,
		31
	],
	"./classic/pt.html": [
		2557,
		32
	],
	"./standard/de.html": [
		2558,
		33
	],
	"./standard/en.html": [
		2559,
		34
	],
	"./standard/es.html": [
		2560,
		35
	],
	"./standard/fr.html": [
		2561,
		36
	],
	"./standard/it.html": [
		2562,
		37
	],
	"./standard/pt.html": [
		2563,
		38
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2535;
module.exports = webpackAsyncContext;